module.exports = __webpack_public_path__ + "static/1-3adea8d77642df08f0b13e2d1ad2f6e2.png";